
const SocketEvent = Object.freeze({
  Connection: 'connection',
  SendNotify: 'send_notify',
  NewNotify: 'new_notify',
  JoinRoom: 'join_room',
  LeaveRoom: 'leave_join',
  LeaveRoomV2: 'leave_room_v2',
  JoinRoomV2: 'join_room_v2',
  sendMessage: 'send_message'
})

/**
 * Chỉ dùng namespace Default vì server chưa care các namespace khác
 */
const SocketNamespace = Object.freeze({
  Default: ''
})

export {
  SocketEvent,
  SocketNamespace
}
